$(document).ready(function () {
setTimeout(function(){
    $(document).find('[data-option="option1"] ul li:first-child').trigger('click');
},1500)
    

  $(document).on("click", ".culotesimple-linkbox", function () {
        var tabtoscroll = $(this).attr('tabtoscroll');
        $('html, body').animate({scrollTop: $('.'+tabtoscroll).offset().top - 200 }, 'slow');

    });


  
    if (window.matchMedia("(max-width: 767px)").matches) {
        ///Mobile Nav
        $(document).on('click', '.dropdown .mobile-menu-first-dsi:not(.excluded)', function (e) {
            e.preventDefault();
            $(this).closest('.nav-item').toggleClass('menu-active');
        })
        $(document).on('click', '.mobile-menu-trigger', function (e) {
            e.preventDefault();
            $(this).closest('.sub-nav-item ').toggleClass('active-child-menu');
        })
        $(document).on('click', '.back-button', function (e) {
            e.preventDefault();
          // return;
            $(this).closest('.nav-item').removeClass('menu-active');
        })
        //

        ///Mobile Nav



        $(".collection-outer-box").slick({
            infinite: true,
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 1,
        });
        $(".mobile-slick-slider").slick({
            infinite: true,
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true
        });


        $(".tabmenu-box-inner").slick({
            infinite: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            nav: true,
            dots: true
        });

        // $('body').on('click', '.tabmenulist-item', function () {
        //     var tabid = $(this).attr('data-tabid');
        //     setTimeout(function () {
        //         $('.tabmenu-box-inner').slick({
        //             infinite: true,
        //             arrows: false,
        //             slidesToShow: 1,
        //             slidesToScroll: 1,
        //             nav: true
        //         });
        //     }, 1000);

        // });
    }

    if ($(window).width() > 767) {
        $(document).on('click', '.dropdown .first-menu-item', function (e) {

            e.preventDefault();
        });
    }

    if ($(window).width() < 767) {
        $(document).on("click", ".tabmenulist-item", function () {
            var tabId = $(this).attr("data-tabid");
            $(document).find("#" + tabId)
                    .find(".tabmenu-box-inner")
                    .slick("unslick");
            setTimeout(function () {

                $(document).find("#" + tabId)
                        .find(".tabmenu-box-inner")
                        .slick({
                            infinite: true,
                            arrows: false,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            nav: true,
                            dots: true
                        });
            }, 50);
        });
    }

    $(document).on("click", "a.reasonlink", function (e) {
        e.preventDefault();
        var parent = $(this).closest(".reason-post-infobox");
        $(parent).toggleClass("show-more");
    });
    $(document).on("click", ".tabmenulist-item", function () {
        var tabid = $(this).attr("data-tabid");
        $(".tabmenulist-item").removeClass("active");
        $(this).addClass("active");
        $(".tabmenu-box").removeClass("active");
        $("#" + tabid).addClass("active");
    });
    $(document).on("change", "#option-couleur", function () {
        var value = $(this).val();
       console.log('her evald k '+value)
    //     return ;
        if (
                $(document).find('.product-gallery[data-color="' + value + '"]').length >
                0
                ) {
                    console.log('here-galleyr')
            $(document).find(".product-gallery").hide();
            $(document)
                    .find('.product-gallery[data-color="' + value + '"]')
                    .show();
            $(document)
                    .find('.product-gallery[data-color="' + value + '"] .thumbnails')
                    .slick("unslick")
                    .off("init reInit setPosition");
        }
    });
    if (
            $(document).find(".color-selector .links").length > 0 &&
            $(document).find("#option-taille").length == 0
            ) {
        $(document).find('[data-btn-type="add-to-cart"]').show();
        $(document).find(".select-size-btn").hide();
    }
    $(document).on(
            "change",
            '[data-option="option1"],[data-option="option2"]',
            function () {
                console.log("here-pp");

                var price = parseInt(
                        $("#price .current-price").text().replace(",", "").replace("€", "")
                        );

                $(document)
                        .find(".quantity_swatch .col-qty")
                        .each(function () {
                            var qty = parseInt($(this).attr("data-qty")),
                                    percentage = parseInt($(this).attr("data-percentage"));
                            if (qty == 1) {
                                qty = 100;
                            }
                            var calculatePr = parseInt((price * qty * percentage) / 100);

                            priceCPT = theme.formatMoney(calculatePr);
                            $(this).find(".price").html(priceCPT);
                            console.log(price + " " + calculatePr + " " + priceCPT);
                        });

                if ($(document).find(".swatches-gd .taille").length > 0) {
                    if (!$(document).find(".swatches-gd .taille").hasClass("selected")) {
                        return true;
                    }
                }

                $(document).find('[data-btn-type="add-to-cart"]').show();
                $(document).find(".select-size-btn").hide();
            }
    );
    $(".size-chart-link").attr("href", "");
    jQuery("body").on("change", ".product-cart-varient-type", function () {
        var variant_id = jQuery(this).val();
        var Quantity = jQuery(this)
                .parents(".cart-summary-item__detail")
                .find(".item-qty-price input[aria-label=Quantity]")
                .val();
        var removebtn = jQuery(this)
                .parents(".cart-summary-item-container")
                .find(".qty-adjuster__remove");
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: "quantity=" + Quantity + "&id=" + variant_id,
            dataType: "json",
            success: function (data) {
                if (data) {
                    jQuery(removebtn).trigger("click");
                    //                    var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
                    //                            .then(response => response.json())
                    //                            .then(data => {
                    //                                return data
                    //                            });
                }
            },
        });
    });

    $(document).on("click", ".videoposterimg", function (e) {
        $(this).hide();
        $(".culotee-video-inner video")[0].play();
    });

    $(document).on("click", ".size-chart-link", function (e) {
        console.log("hjhh");
        e.preventDefault();
    });
    $(document).on("click", ".btn-custom-pro", function (e) {
        e.preventDefault();
        $("html, body").animate(
                {
                    scrollTop: $("button[data-btn-type='add-to-cart']").offset().top - 170,
                },
                2000
                );
    });
    $(document).on("click", "#stikcy-product-bar", function (e) {
        e.preventDefault();
        $("html, body").animate(
                {
                    scrollTop: $("button[data-btn-type='add-to-cart']").offset().top - 200,
                },
                2000
                );
    });

    jQuery(".readmore").on("click", function () {
        jQuery(this).parent(".mobiletextbox").addClass("showall");
    });
    jQuery(".readless").on("click", function () {
        jQuery(this).parent(".mobiletextbox").removeClass("showall");
    });

    const swiper = new Swiper(".reason-slider-main", {
        loop: true,
        slidesPerView: 3,
        spaceBetween: 30,
        freeMode: true,
        navigation: {
            prevEl: ".swiper-button-prev",
            nextEl: ".swiper-button-next",
        },
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            // when window width is >= 480px
            480: {
                slidesPerView: 1,
                spaceBetween: 30,
            },
            // when window width is >= 640px
            640: {
                slidesPerView: 2,
                spaceBetween: 30,
            },

            991: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
        },
    });

    $(".announce-slider").slick({
        infinite: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        prevArrow:
                '<button type="button" class="slick-prev ann"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"> <path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"></path> <path d="M0-.75h24v24H0z" fill="none"></path> </svg></button>',
        nextArrow:
                '<button type="button" class="slick-next ann"><svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"> <path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"></path> <path d="M0-.75h24v24H0z" fill="none"></path> </svg></button>',
    });

    $(".Product-features-top-bar.mobile-only").slick({
        infinite: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
    });
    $(".mobile-only .culotte-features-boxes-inner").slick({
        infinite: true,
        arrows: false,
        slidesToShow: 2,
        slidesToScroll: 1,
    });
    if ($(window).width() < 991) {
        $(".press-blocks.disp-flex").slick({
            infinite: true,
            arrows: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            responsive: [
                {
                    breakpoint: 676,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                    },
                },
            ],
        });
    }

    if ($(window).width() < 1125) {
        $(".upsell_products").slick({
            infinite: false,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
        });
    }
    $(".cart-summary__section.inline-flex-gd").slick({
        infinite: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
    });
    $(".logo-vidos").slick({
        infinite: true,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        prevArrow:
                "<button type='button' class='slick-prev pull-left'><svg width='20' height='33' viewBox='0 0 20 33' fill='none' xmlns='http://www.w3.org/2000/svg'> <path d='M18 31L2 16.5L18 2' stroke='#A27D62' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'/> </svg></button>",
        nextArrow:
                "<button type='button' class='slick-next pull-right'><svg width='20' height='33' viewBox='0 0 20 33' fill='none' xmlns='http://www.w3.org/2000/svg'> <path d='M2 31L18 16.5L2 2' stroke='#A27D62' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'/> </svg></button>",
        responsive: [
            {
                breakpoint: 676,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                },
            },
        ],
    });
    $(".product-logo-list").slick({
        infinite: true,
        arrows: false,
        slidesToShow: 6,
        slidesToScroll: 6,
        responsive: [
            {
                breakpoint: 676,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                },
            },
        ],
    });
    // $(".press-blocks.disp-flex").slick({
    //   infinite: true,
    //   arrows: false,
    //   slidesToShow: 3,
    //   slidesToScroll: 3,
    //   responsive: [
    //     {
    //       breakpoint: 676,
    //       settings: {
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         dots: false,
    //       },
    //     },
    //   ],
    // });
    var colorName = $(document).find(".color-selector .links a.on").attr("title");
    if (colorName !== undefined) {
        $(document).find(".color-name-sp").text(colorName);
    }

    $(document).on("click", ".quantity_swatch .col-qty", function () {
        var parent = $(this).closest(".quantity_swatch");
        $(parent).find(".col-qty").removeClass("col-selected");
        $(this).addClass("col-selected");
        var qty = $(this).attr("data-qty");
        $(document).find('[name="quantity"]').val(qty);
        var price = $(this).find(".price").text();
        $(document).find('[name="add"] .btn-price').text(price);
    });

    $(document).on("click", ".swatches-gd ul li", function () {
        var parent = $(this).closest(".swatches-gd"),
                opt = $(parent).attr("data-option"),
                value = $(this).attr("data-value");
        $(parent).find("ul li").removeClass("selected");
        $(this).addClass("selected");
        $(parent).find(".selected-val").text(value);
        $(document)
                .find('select[data-option="' + opt + '"]')
                .val(value)
                .trigger("change");

        if ($(this).hasClass("couleur")) {
            console.log("herer-color");
            return true;
        }
        console.log("herer-color-rest");
        $(document).find('[data-btn-type="add-to-cart"]').show();
        $(document).find(".select-size-btn").hide();
    });
    $(document).on("click", ".faq-blocks .block-title", function () {
        $(this).toggleClass("active-fq");
        $(this).next(".desc-blocks").slideToggle();
    });

    $("#option-taille, #option-couleur, #option-tailles").niceSelect();

    $(".product-block .color-selector .links a")
            .mouseenter(function () {
                $(this)
                        .closest(".product-block")
                        .find(".image__color")
                        .css({"background-image": "url(" + $(this).data("image") + ")"})
                        .show();
            })
            .mouseleave(function () {
                $(this).closest(".product-block").find(".image__color").hide();
            });

    $(".product-block .links-gd-in")
            .mouseenter(function () {
                $(this)
                        .closest(".product-block")
                        .find(".image__color")
                        .css({"background-image": "url(" + $(this).data("image") + ")"})
                        .show();
            })
            .mouseleave(function () {
                $(this).closest(".product-block").find(".image__color").hide();
            });

    $(".accordion p").hide();
    $(".accordion h3").click(function (e) {
        e.preventDefault();

        var p = $(this).next();

        $(".accordion p:visible").not(p).slideUp();
        $(".accordion h3").removeClass("open");

        p.slideDown();
        $(this).addClass("open");
    });

    SortSidebarFilters();
});

function SortSidebarFilters() {
    $("#CollectionFilterFormSideBar .cc-accordion").each(function () {
        $(this)
                .find(".cc-checkbox")
                .sort(SortSidebarFilters_function)
                .appendTo($(this).find(".cc-accordion-item__content"));
    });
}
function SortSidebarFilters_function(a, b) {
    return $(b).data("position") < $(a).data("position") ? 1 : -1;
}
setInterval(function () {
    var getDiscountedPrice = $(document)
            .find(
                    ".sc_simple-info .sc_simple-info__row:not(.sc_code-info) .money.mw-price"
                    )
            .text();
    //console.log(getDiscountedPrice);
    if (getDiscountedPrice != "" && getDiscountedPrice != undefined) {
        $(document)
                .find('#cart-summary [name="checkout"] .icon-price')
                .text(getDiscountedPrice);
    }
  if( $(document).find('.docapp-est-total .docapp-right .buckscc-money').length > 0 ){
    var priceVal = $(document).find('.docapp-est-total .docapp-right .buckscc-money').text()
    $(document).find('#cart-summary [name="checkout"] .button-text .icon-price').text(priceVal);
  }
}, 1000);

